export enum HeightType {
  FIXED = 'fixed',
  AUTO = 'auto',
}
